module.exports = __webpack_public_path__ + "img/researchbooklet.02dfb5ab.jpg";